import Action from '../../actions/paymentDictionary'
import {
  IInvoiceSettings,
  IPaymentDictionary,
  IPrepaymentMethod,
  ITaxesDictionary,
} from '../../models/PaymentDictionary'
import { AuthorizationActions } from '../userAccount/actionNames'
import { IServices } from '../../models/PaymentDictionary/loadTaxServices'
import { IDefaultServices } from '../../models/PaymentDictionary/loadDefaultTaxServices'
import { IPhoto } from '../../models/Photos'
import { PaymentDictionaryActions } from './actionNames'
import initialState from './initialState'
import dictionariesAreAccepted from './mutators/dictionariesAreAccepted'
import dictionariesAreRejected from './mutators/dictionariesAreRejected'
import requestForDictionaries from './mutators/requestForDictionaries'

export default function(
  store: IPaymentDictionaryStore = initialState,
  action: Action & any,
): IPaymentDictionaryStore {
  switch (action.type) {
    case PaymentDictionaryActions.RequestPaymentDictionary:
      return requestForDictionaries(store)
    case PaymentDictionaryActions.PaymentDictionaryAccepted:
      return dictionariesAreAccepted(store, action)
    case PaymentDictionaryActions.PaymentDictionaryRejected:
      return dictionariesAreRejected(store, action)
    case AuthorizationActions.FlushState:
      return { ...initialState }
    case PaymentDictionaryActions.TaxDictionaryAccepted:
      return {
        ...store,
        taxDictionaries: (action as any).dict,
      }
    case PaymentDictionaryActions.AcceptedInvoiceSettings:
      return {
        ...store,
        invoiceSettings: (action as any).settings[0],
      }
    case PaymentDictionaryActions.AcceptedDefaultServices:
      return {
        ...store,
        defaultServices: (action as any).services[0],
      }
    case PaymentDictionaryActions.AcceptedServices:
      return {
        ...store,
        services: (action as any).services,
      }
    case PaymentDictionaryActions.AcceptedPaymentMethod:
      return {
        ...store,
        paymentMethod: (action as any).paymentMethod,
        error: false,
      }
    case PaymentDictionaryActions.PaymentMethodError:
      return {
        ...store,
        error: true,
      }
  }
  return store
}

export interface IPaymentDictionaryStore {
  dictionaries: IPaymentDictionary[]
  taxDictionaries: ITaxesDictionary[]
  invoiceSettings: IInvoiceSettings
  services: IServices[]
  paymentMethod: IPrepaymentMethod
  defaultServices: IDefaultServices
  photos: IPhoto[]
  error: boolean
  request: {
    isLoading: boolean
    errMessage: string
  }
}
